export const showDetailsCrumbItems = [
    {
        id: '',
        text: 'Showyeda admin',
        disabled: true,
    },
    {
        id: '',
        text: 'Show Details',
        disabled: true,
    },
];
